import { twdClass } from "../../constants/tailwind.constants";
import Select from "react-select";
import { Button, BtnStyle, BtnDelete, BtnEdit} from "../ui/com_ui";

export const VideoElementPanel = ({
  columnNames = [],
  section,
  updateValues,
  updateStylePanel,
}) => {
  const optionList = columnNames.map((itm) => ({
    value: itm.key,
    label: itm.value,
  }));
  return (
    <div>
      <div className={twdClass("items-start mb-4")}>
        <div className={twdClass("w-36 text-sm mb-2")}>Map Columns:</div>
        <div className={twdClass("w-full text-xs")}>
          <Select
            name="image-element"
            defaultValue={[]}
            options={optionList}
            onChange={(value) => {
              updateValues(section.id, { params: value });
            }}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderRadius:'20px',                
              }),
            }}
          />
        </div>
      </div>
      <div className={twdClass("text-sm mb-2")}>
        <div className={twdClass("flex justify-between items-center")}>
          <label>Video Style:</label>
          <div>
            <BtnStyle              
              title="Style"
              onClick={() => {
                updateStylePanel({ sectionId: section.id, showStyles: true });
              }}
            >              
            </BtnStyle>
          </div>
        </div>
      </div>
    </div>
  );
};
